<div class="chat-container">
    <div class="sidebar">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <h4>Agents: </h4>
        <mat-form-field fxFlex appearance="outline" class="agent-list" *ngIf="agents">
          <mat-select #agentField placeholder="Pricing Model" matTooltip="Choose Your Agent" [(ngModel)]="selectedAgent" (ngModelChange)="selectAgent($event)">
              <mat-option *ngFor="let a of agents" [value]="a">
                  {{a.name}}
              </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="threads">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
          <h4>Threads</h4>
          <div fxFlex></div>
          <button mat-raised-button (click)="createNewThread(true)" [disabled]="waitingForAi">New Thread</button>
        </div>
        <mat-slide-toggle [(ngModel)]="streaming" color="primary">streaming</mat-slide-toggle>
        <ul>
          <li *ngFor="let thread of threads" (click)="selectThread(thread)" [class.active]="selectedThread?._id === thread._id" [class.no-click]="waitingForAi">
            <div fxLayout="row" fxLayoutAlign="start center" style="width: 100%">
              <div>{{ thread.name }}</div>
              <div fxFlex></div>
              <rubii-button theme="primary" icon="delete" buttonType="icon" (onClick)="deleteThread(thread._id, $event)"></rubii-button>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="chat-main">
      <div #chatMessages class="chat-messages" *ngIf="selectedThread">
        <div class="thread-header-container">
          <h4 class="thread-name">{{selectedThread.name}}</h4>
          <div class="token-stats" *ngIf="selectedThread?.tokenUsed">
            <div *ngIf="selectedThread.tokenUsed">Token Used: {{selectedThread.tokenUsed}}</div>
            <div *ngIf="selectedThread.inputTokenUsed">Input Token Used: {{selectedThread.inputTokenUsed}}</div>
            <div *ngIf="selectedThread.outputTokenUsed">Output Token Used: {{selectedThread.outputTokenUsed}}</div>
            <div *ngIf="selectedThread.cacheWriteTokenUsed">Cache Write Token Used: {{selectedThread.cacheWriteTokenUsed}}</div>
            <div *ngIf="selectedThread.cacheReadTokenUsed">Cache Read Token Used: {{selectedThread.cacheReadTokenUsed}}</div>
          </div>
        </div>
        <div *ngFor="let message of selectedThread.messages" [ngClass]="{'user-message': message.role === 'user', 'ai-message': message.role === 'assistant'}">
          <div *ngIf="message.role === 'user'">
            <p *ngIf="message.content" [innerHTML]="message.content" class="markdown-body" [style]="shouldUseMonospace(message.content) ? 'white-space: pre; overflow-x: auto; font-family: Consolas, \'Courier New\', monospace; font-size: 14px;' : ''"></p>
            <div *ngIf="message.imageUrl || message.image">
              <img style="width: 50%; cursor: pointer;" 
                   [src]="message.imageUrl || message.image" 
                   alt="User Image"
                   (click)="openImageModal(message.imageUrl || message.image)">
            </div>
            <div class="message-actions" *ngIf="message.content">
              <button mat-icon-button matTooltip="Like">
                <mat-icon>thumb_up</mat-icon>
              </button>
              <button mat-icon-button matTooltip="Dislike">
                <mat-icon>thumb_down</mat-icon>
              </button>
              <button mat-icon-button matTooltip="Copy to clipboard" (click)="copyMessageToClipboard(message.content)">
                <mat-icon>content_copy</mat-icon>
              </button>
            </div>
          </div>
          <div *ngIf="message.role === 'assistant'">
            <div class="message-token-stats" *ngIf="message.inputTokenUsed && !message.toolOutput?.length">{{message.inputTokenUsed}}/{{message.outputTokenUsed}}</div>
            <p *ngIf="message.content" [innerHTML]="markDownService.parse(message.content)" class="markdown-body"></p>
            <div class="message-actions" *ngIf="message.content">
              <button mat-icon-button matTooltip="Like">
                <mat-icon>thumb_up</mat-icon>
              </button>
              <button mat-icon-button matTooltip="Dislike">
                <mat-icon>thumb_down</mat-icon>
              </button>
              <button mat-icon-button matTooltip="Copy to clipboard" (click)="copyMessageToClipboard(message.content)">
                <mat-icon>content_copy</mat-icon>
              </button>
            </div>
          </div>
          <div *ngIf="message.role == 'tool'" class="tool-call-container">
            <app-ai-message-tool 
              *ngFor="let tool of message.toolCalls" 
              [toolName]="tool.function.name"
              [toolInput]="tool.function.arguments"
              [toolOutput]="findToolOutput(tool._id, message)"
              [isLoading]="!findToolOutput(tool._id, message)"
              [explanation]="tool.function.explanation">
            </app-ai-message-tool>
          </div>
        </div>
      </div>
      <!-- <markdown [data]="testMarkdownContent" class="markdown-body"></markdown> -->
      <!-- <div [innerHTML]="parsedMarkdownContent"></div> -->
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="file-upload-container">
        <button mat-icon-button color="primary" (click)="fileInputElement.click()" [disabled]="waitingForAi || uploadedFiles.length > 0" matTooltip="Upload file (PDF, Excel, CSV, Image)">
          <mat-icon>attach_file</mat-icon>
        </button>
        <button mat-stroked-button *ngIf="hasTemplateKeys()" (click)="toggleTemplateInjection()" class="template-injection-btn" [class.active]="showTemplateInjection">
          Inject Template Values
        </button>
        <input #fileInputElement type="file" style="display:none" 
               accept=".pdf,.xlsx,.csv,.jpg,.jpeg,.png,.gif" 
               (change)="handleFileInput($event)">
        <div class="textarea-container" fxFlex [class.dragging]="isDragging">
          <div *ngIf="uploadedFiles.length > 0" class="uploaded-files-list">
            <div *ngFor="let item of uploadedFiles; let i = index" class="uploaded-file-item">
              <mat-icon>{{getFileIcon(item.file.type)}}</mat-icon>
              <span class="file-name">{{item.file.name}}</span>
              <button mat-icon-button class="remove-file-btn" (click)="removeFile(i)">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
          <div class="textarea-input-wrapper">
            <textarea 
              #messageInput
              class="auto-resize-textarea"
              [(ngModel)]="newMessage" 
              placeholder="Type your message or drop files here..." 
              [disabled]="waitingForAi"
              (keydown)="onKeyDown($event)"
              (drop)="onFileDrop($event)"
              (dragover)="onDragOver($event)"
              (dragenter)="onDragEnter($event)"
              (dragleave)="onDragLeave($event)"
              (paste)="onPaste($event)"
              rows="1"></textarea>
            <rubii-button class="textarea-stop-btn" theme="accent" icon="stop" buttonType="icon" [iconSize]="2" [disabled]="!waitingForAi" matTooltip="Stop generation" (click)="stopGeneration()">
            </rubii-button>
          </div>
        </div>
        <button mat-raised-button color="primary" (click)="sendMessage()" [disabled]="waitingForAi">Send</button>
      </div>
      
      <!-- Template Injection Panel -->
      <div class="template-injection-panel" [class.show]="showTemplateInjection" *ngIf="hasTemplateKeys()">
        <div class="template-injection-content">
          <h4>Template Values</h4>
          <div class="template-keys-container">
            <mat-form-field appearance="outline" *ngFor="let key of selectedAgent.templateKeys" class="template-key-field">
              <mat-label>{{key}}</mat-label>
              <input matInput [(ngModel)]="templateKeyValues[key]" (ngModelChange)="updateTemplateKeyValue(key, $event)" placeholder="Enter value for {{key}}">
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
